import { render, staticRenderFns } from "./AddSupplierB.vue?vue&type=template&id=6064c5fb&scoped=true&"
import script from "./AddSupplierB.vue?vue&type=script&lang=js&"
export * from "./AddSupplierB.vue?vue&type=script&lang=js&"
import style0 from "./AddSupplierB.vue?vue&type=style&index=0&id=6064c5fb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064c5fb",
  null
  
)

export default component.exports